<template>
    <div class="container-verifypage" v-loading="loading">
        <el-steps :active="active" finish-status="success" class="mgb-60">
            <el-step title="提交资料"></el-step>
            <el-step title="开户验证"></el-step>
            <el-step title="开户审核"></el-step>
            <el-step title="扫码签约"></el-step>
            <el-step title="开户成功"></el-step>
        </el-steps>
        <!-- step1 -->
        <div class="step-container" v-if="active === 0">
            <el-form
                :model="form"
                :rules="rules"
                ref="form"
                label-position="left"
                label-width="200px"
                style="max-width: 1000px;"
            >
                <!-- 主体类型 -->
                <el-form-item label="主体类型" prop="supplierType">
                    <el-radio-group v-model="form.supplierType">
                        <el-radio
                            v-for="item in supplierTypeSelectList"
                            :key="item.value"
                            :label="item.value"
                            :disabled="item.disabled || (reshowData && commonQualificationDto.supplierType)"
                            @change="supplierTypeChange"
                        >
                            {{ item.label }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <!-- 纸质营业执照todo -->
                <!-- https://trade.baidu.com/platform/interface/uploadimg -->
                <div class="area-box" v-loading="ocrLoading">
                    <div class="area-title"><span style="color:red">*</span>纸质营业执照</div>
                    <div class="area-content">
                        <div class="upload-box">
                            <imgUpload ref="myLicenseUpload" @upload-success="handleChildUploadSuccess"/>
                            <el-button v-if="noNameAndNoCode && form.companyName && form.businessLicense" type="primary" @click="searchBusinessLicense">点击自动提交</el-button>
                            <p>填写规则</p>
                            <p>1.系统支持自动识别填写，如识别有误可手动调整</p>
                            <p>2.需和营业执照上的公司“名称”保持一致</p>
                            <p>3.名称里含有“（）”的请注意中英格式，正确填写。</p>
                            <p>4.请上传证件的彩色扫描件或彩色数码拍摄件，黑白复印件需加盖公章（公章信息需完整）。不得添加无关水印（非微信支付商户申请用途的其他水印）</p>
                            <p>5.确保未在企业经营异常名录中，且所售商品在营业执照经营范围内</p>
                            <p>6.图片大小不超过5MB，格式支持jpg,jpeg,bmp,png</p>
                        </div>
                        <!-- 以下为自动填充 -->
                        <!-- 企业名称 -->
                        <el-form-item label="企业名称" prop="companyName">
                            <el-input
                                size="medium"
                                v-model="form.companyName"
                                style="max-width: 400px;"
                                :disabled="reshowData && commonQualificationDto.companyName"
                            ></el-input>
                            <div v-if="noNameAndNoCode && form.companyName && form.businessLicense" class="sub-note">
                                <p>1、长度为2-128个字符</p>
                                <p>2、前后不能有空格、制表符、换行符</p>
                                <p>3、不能仅含数字、特殊字符</p>
                                <p>4、仅能填写数字、英文字母、汉字及特殊字符</p>
                                <p>5、仅支持utf-8格式</p>
                                <p>6、个体户证件为以下情况时，按照个体户XXX命名（XXX是营业执照经营人姓名）：营业执照登记名称为空、仅含数字、仅含特殊字符、“无”、“无字号”</p>
                                <p>7、个体户不能使用“企业”“公司”或“农民专业合作社”结尾</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="行业类目" prop="industryId">
                            <!-- 请选择一级行业 -->
                            <el-select v-model="industryLevel1" placeholder="请选择一级行业" @change="handleChangeLevel1">
                                <el-option
                                    v-for="(item, index) in industryListData"
                                    :key="item.industryId"
                                    :label="item.industryName"
                                    :value="index">
                                </el-option>
                            </el-select>
                            <!-- 请选择二级行业 -->
                            <el-select v-model="industryLevel2" placeholder="请选择二级行业" @change="handleChangeLevel2" v-if="industryListDataLevel2">
                                <el-option
                                    v-for="(item, index) in industryListDataLevel2"
                                    :key="item.industryId"
                                    :label="item.industryName"
                                    :value="index">
                                </el-option>
                            </el-select>
                            <!-- 请选择三级行业 -->
                            <el-select v-model="industryLevel3" placeholder="请选择三级行业" @change="handleChangeLevel3" v-if="industryListDataLevel3">
                                <el-option
                                    v-for="(item, index) in industryListDataLevel3"
                                    :key="item.industryId"
                                    :label="item.industryName"
                                    :value="index">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 统一社会代码 -->
                        <el-form-item label="统一社会代码" prop="businessLicense">
                            <el-input
                                size="medium"
                                v-model="form.businessLicense"
                                style="max-width: 400px;"
                                :disabled="reshowData && commonQualificationDto.businessLicense"
                            ></el-input>
                        </el-form-item>
                        <!-- 公司类型 -->
                        <!-- <el-form-item label="公司类型" prop="type">
                            <el-input
                                size="medium"
                                v-model="form.type"
                                style="max-width: 400px;"
                            ></el-input>
                        </el-form-item> -->
                        <!-- 营业执照有效期 -->
                        <el-form-item label="营业执照有效期" prop="licenseStartTime">
                            <el-date-picker
                                v-model="form.licenseStartTime"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="营业执照-有效期"
                                :disabled="reshowData && commonQualificationDto.licenseStartTime"
                            >
                            </el-date-picker>
                            <el-date-picker
                                v-model="form.licenseEndTime"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="营业执照-有效期"
                                :disabled="reshowData && commonQualificationDto.licenseEndTime"
                            >
                            </el-date-picker>
                            <el-checkbox
                                v-model="licenselongtime"
                                @change="handleLicenseLongTimeChange"
                                :disabled="reshowData && commonQualificationDto.licenseEndTime.indexOf('9999') !== -1"
                            >
                                长期有效
                            </el-checkbox>
                        </el-form-item>
                        <!-- 注册资本 -->
                        <!-- <el-form-item label="注册资本" prop="registeredCapital">
                            <el-input
                                size="medium"
                                v-model="form.registeredCapital"
                                style="max-width: 400px;"
                            ></el-input>
                        </el-form-item> -->
                        <!-- 经营省市 todo-->
                        <el-form-item label="经营省市" prop="businessProvince">
                            <!-- 请选择经营省份 -->
                            <el-select v-model="bankCityLevel1" placeholder="请选择经营省份" @change="handleChangeCity1">
                                <el-option
                                    v-for="(item, index) in bankCityList"
                                    :key="item.provinceName"
                                    :label="item.provinceName"
                                    :value="index">
                                </el-option>
                            </el-select>
                            <!-- 请选择经营城市 -->
                            <el-select v-model="bankCityLevel2" placeholder="请选择经营城市" @change="handleChangeCity2" v-if="bankCityListLevel2">
                                <el-option
                                    v-for="(item, index) in bankCityListLevel2"
                                    :key="item.cityName"
                                    :label="item.cityName"
                                    :value="index">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 经营场所 -->
                        <el-form-item label="经营地址" prop="businessDetailAddress">
                            <el-input
                                size="medium"
                                v-model="form.businessDetailAddress"
                                style="max-width: 400px;"
                                :disabled="reshowData && commonQualificationDto.businessDetailAddress"
                            ></el-input>
                        </el-form-item>
                        <!-- 经营范围 -->
                        <el-form-item label="经营范围" prop="businessScope">
                            <el-input
                                type="textarea"
                                size="medium"
                                v-model="form.businessScope"
                                style="max-width: 400px;"
                                :rows="5"
                                :disabled="reshowData && commonQualificationDto.businessScope"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
                <!-- 证件类型 -->
                <el-form-item label="证件类型" prop="legalPersonType">
                    <el-select
                        v-model="form.legalPersonType"
                        placeholder="请选择"
                        @change="legalPersonTypeChange"
                        :disabled="reshowData && commonQualificationDto.legalPersonType"
                    >
                        <el-option
                            v-for="item in legalPersonTypeList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <div class="idcard-box mgl-100">
                    <imgUpload ref="myLegalUploadFront" @upload-success="handleLegalIdCardFrontUploadSuccess" :content="form.legalPersonType === 1 ? '上传人像面': '上传证件'" initUrl=""/>
                    <imgUpload v-if="form.legalPersonType === 1" ref="myLegalUploadEnd" @upload-success="handleLegalIdCardBackUploadSuccess" content="上传国徽面"/>
                </div>
                <!-- <div v-show="form.legalPersonType === 1"> -->
                    <!-- 身份证姓名不支持修改 -->
                <el-form-item label="姓名" prop="legalPerson">
                    <el-input
                        size="medium"
                        v-model="form.legalPerson"
                        style="max-width: 400px;"
                        :disabled="form.legalPersonType === 1 && (reshowData && commonQualificationDto.legalPerson)"
                    ></el-input>
                </el-form-item>
                <el-form-item label="证件号" prop="legalId">
                    <el-input
                        size="medium"
                        v-model="form.legalId"
                        style="max-width: 400px;"
                        :disabled="reshowData && commonQualificationDto.legalId"
                    ></el-input>
                </el-form-item>
                <el-form-item label="证件有效期" prop="legalCardEndTime">
                    <el-date-picker
                        v-model="form.legalCardStartTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="开始时间"
                        :disabled="reshowData && commonQualificationDto.legalCardStartTime">
                    </el-date-picker>
                    <el-date-picker
                        v-model="form.legalCardEndTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="结束时间"
                        :disabled="reshowData && commonQualificationDto.legalCardEndTime">
                    </el-date-picker>
                    <el-checkbox
                        v-model="legallongtime"
                        @change="handleLegalLongTimeChange"
                        :disabled="reshowData && commonQualificationDto.legalCardStartTime && commonQualificationDto.legalCardEndTime"
                    >
                        长期有效
                    </el-checkbox>
                </el-form-item>
                <el-form-item v-if="form.legalPersonType === 1" label="身份证居住地址" prop="legalPersonAddress">
                    <el-input
                        size="medium"
                        v-model="form.legalPersonAddress"
                        style="max-width: 400px;"
                        :disabled="reshowData && commonQualificationDto.legalPersonAddress"
                    ></el-input>
                </el-form-item>

                <!-- </div> -->
                <!-- 企业最终受益人 -->
                <el-form-item label="企业最终受益人" prop="owner">
                    <el-radio-group v-model="form.owner">
                        <el-radio
                            v-for="item in benefitTypeList"
                            :key="item.value"
                            :label="item.value"
                            :disabled="item.disabled && (reshowData && commonQualificationDto.owner)"
                            @change="handleBenefitChange"
                        >
                            {{ item.label }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <p class="sub-title">商户经营信息</p>
                <!-- -------------------------------商户经营信息------------------------------- -->
                <!-- 服务名称 -->
                <el-form-item label="服务名称" prop="appName">
                    <el-input
                        size="medium"
                        v-model="form.appName"
                        style="max-width: 400px;"
                        placeholder="请填写服务名称，3-10个字符"
                        :disabled="reshowData && commonQualificationDto.appName"
                    ></el-input>
                </el-form-item>
                <!-- 商家简称 不做 -->
                <!-- 客服电话 -->
                <el-form-item label="客服电话" prop="servicePhone">
                    <el-input
                        size="medium"
                        v-model="form.servicePhone"
                        style="max-width: 400px;"
                        placeholder="请填写客服电话，方便用户联系商家"
                        :disabled="reshowData && commonQualificationDto.servicePhone"
                    ></el-input>
                </el-form-item>
                <!-- -------------------------------管理员信息 ocr识别 todo------------------------------- -->
                <div class="area-box">
                    <div class="area-title"><span style="color:red">*</span>管理员信息</div>
                    <div class="area-content">
                        <!-- 管理员类型 -->
                        <el-form-item label="类型" prop="superAdminType">
                            <el-radio-group v-model="form.superAdminType">
                                <el-radio
                                    v-for="item in superAdminTypeSelectList"
                                    :key="item.value"
                                    :label="item.value"
                                    :disabled="item.disabled"
                                    @change="handleSuperAdminTypeChange"
                                >
                                    {{ item.label }}
                                </el-radio>
                            </el-radio-group>
                            <div class="idcard-box">
                                <imgUpload ref="myAdminUploadFront" @upload-success="handleIdCardFrontUploadSuccess" content="请传入身份证正面照"/>
                                <imgUpload ref="myAdminUploadEnd" @upload-success="handleIdCardBackUploadSuccess" content="请传入身份证背面照"/>
                            </div>
                        </el-form-item>
                        <!-- 超级管理员姓名 -->
                        <el-form-item label="姓名" prop="superAdminName">
                            <el-input
                                size="medium"
                                v-model="form.superAdminName"
                                style="max-width: 400px;"
                                placeholder="请输入管理员姓名"
                            ></el-input>
                        </el-form-item>
                        <!-- 超级管理员身份证号 -->
                        <el-form-item label="身份证号" prop="adminPersonId">
                            <el-input
                                size="medium"
                                v-model="form.adminPersonId"
                                style="max-width: 400px;"
                                placeholder="请输入管理员身份证号"
                            ></el-input>
                        </el-form-item>
                        <!-- 超级管理员身份证有效期todo -->
                        <el-form-item label="身份证有效时间" prop="">
                            <el-date-picker
                                v-model="form.adminCardStartTime"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="身份证开始时间">
                            </el-date-picker>
                            <el-date-picker
                                v-model="form.adminCardEndTime"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="身份证结束时间">
                            </el-date-picker>
                        </el-form-item>
                        <!-- 超级管理员手机号 -->
                        <el-form-item label="手机号" prop="superAdminPhone">
                            <el-input
                                size="medium"
                                v-model="form.superAdminPhone"
                                style="max-width: 400px;"
                                placeholder="用于接收短信验证和通知"
                            ></el-input>
                        </el-form-item>
                        <!-- 超级管理员邮箱 -->
                        <el-form-item label="邮箱" prop="superAdminEmail">
                            <el-input
                                size="medium"
                                v-model="form.superAdminEmail"
                                style="max-width: 400px;"
                                placeholder="用于接收开户邮件以及通知"
                            ></el-input>
                        </el-form-item>
                        <!-- 业务办理授权函 -->
                        <el-form-item v-if="form.superAdminType !== 65" label="业务办理授权函" prop="businessAuthorizationLetterUrl">
                            <imgUpload ref="myAuthorizationLetterUpload" @upload-success="businessAuthorizationLetterUrlUploadSuccess" content="业务办理授权函"/>
                        </el-form-item>
                        <!-- 特殊资质信息 -->
                        <el-form-item label="特殊资质信息" prop="qualifications">
                            <imgUpload ref="myQualificationsUpload" @upload-success="qualificationsUploadSuccess" content="特殊资质信息"/>
                        </el-form-item>
                    </div>
                </div>
                <!-- 支付商家名称 -->
                <el-form-item label="支付商家名称" prop="merchantShortName">
                    <el-input
                        size="medium"
                        v-model="form.merchantShortName"
                        style="max-width: 400px;"
                        placeholder="请输入支付商家名称"
                    ></el-input>
                </el-form-item>
                <!-- 支付商家头像 -->
                <el-form-item label="支付商家头像" prop="payMerchantTitleUrl">
                    <div class="upload-box">
                        <imgUpload @upload-success="handlePayMerchantdUploadSuccess"/>
                    </div>
                </el-form-item>
                <!-- 支付商家跳转链接 -->
                <el-form-item label="支付商家跳转链接" prop="storeUrl">
                    <el-input
                        size="medium"
                        v-model="form.storeUrl"
                        style="max-width: 400px;"
                        placeholder="请输入支付商家跳转链接"
                    ></el-input>
                </el-form-item>
                <p class="sub-title">商户结算账户信息</p>
                <!-- -------------------------------商户结算账户信息------------------------------- -->
                <!-- 账户类型 -->
                <el-form-item label="账户类型" prop="bankAccountType">
                    <el-radio-group v-model="form.bankAccountType">
                        <el-radio
                            v-for="item in bankAccountTypeSelectList"
                            :key="item.value"
                            :label="item.value"
                            :disabled="item.disabled"
                        >
                            {{ item.label }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <!-- 开户名 自动带入企业名称和法人姓名？todo-->
                <el-form-item label="开户名" prop="bankAccount">
                    <el-input
                        size="medium"
                        v-model="form.bankAccount"
                        style="max-width: 400px;"
                        placeholder="请输入企业名称或法人姓名"
                    ></el-input>
                </el-form-item>
                <!-- 银行卡号 -->
                <el-form-item label="银行卡号" prop="accountNumber">
                    <el-input
                        size="medium"
                        v-model="form.accountNumber"
                        style="max-width: 400px;"
                        placeholder="请输入银行卡号"
                    ></el-input>
                </el-form-item>
                <!-- 开户银行名称 todo 开户银行和支行名称似乎只需要一个，需要和后端对齐 -->
                <el-form-item label="开户银行名称" prop="bankName">
                    <el-input
                        size="medium"
                        v-model="form.bankName"
                        style="max-width: 400px;"
                        placeholder="请输入开户银行名称"
                    ></el-input>
                </el-form-item>
                <!-- 开户银行支行名称 -->
                <el-form-item label="开户银行支行名称" prop="bankBranchName">
                    <el-input
                        size="medium"
                        v-model="form.bankBranchName"
                        style="max-width: 400px;"
                        placeholder="请输入开户银行支行名称"
                    ></el-input>
                </el-form-item>
                <p class="sub-title">商户财务结算信息</p>
                <!-- -------------------------------商户财务结算信息------------------------------- -->
                <!-- 结算方式 缺少字段 todo -->
                <!-- <el-form-item label="结算方式" prop="bankAccountType">
                    <el-radio-group v-model="form.bankAccountType">
                        <el-radio
                            v-for="item in splitTypeSelectList"
                            :key="item.value"
                            :label="item.value"
                            :disabled="item.disabled"
                        >
                            {{ item.label }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item> -->
                <!-- 结算周期 -->
                <el-form-item label="结算周期" prop="paymentDays">
                    <el-select
                        v-model="form.paymentDays"
                        placeholder="请选择"
                        :disabled="reshowData && commonQualificationDto.paymentDays"
                    >
                        <el-option
                            v-for="item in capitalSettlementTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select> 天
                </el-form-item>
                <!-- 技术服务费 -->
                <el-form-item label="技术服务费" prop="commissionRateStr">
                    <el-input
                        size="medium"
                        v-model="form.commissionRateStr"
                        style="max-width: 400px;"
                        placeholder="请输入技术服务费"
                        :disabled="reshowData && commonQualificationDto.commissionRateStr"
                    ></el-input> %
                </el-form-item>
                <!-- 打款预留（元） -->
                <el-form-item label="打款预留" prop="poolCashPledge">
                    <el-input
                        size="medium"
                        v-model="form.poolCashPledge"
                        style="max-width: 400px;"
                        placeholder="请输入打款预留"
                        :disabled="reshowData && commonQualificationDto.poolCashPledge"
                    ></el-input> 元
                </el-form-item>
                <!-- 分账信息 -->
                <!-- <div class="split-box">
                    <div class="area-title"><span style="color:red">*</span>分账信息</div>
                    <el-radio-group class="mgl-100" v-model="isSplit">
                        <el-radio
                            label="0"
                        >
                            不分账
                        </el-radio>
                        <el-radio
                            label="1"
                        >
                            分账
                        </el-radio>
                    </el-radio-group>
                </div> -->
                <div class="area-box mgl-100" v-show="isSplit === '1'">
                    <div class="area-content">
                        <!-- 分账对象 -->

                        <!-- 分账方企业名称 -->
                        <el-form-item label="分账方企业名称" prop="adminPersonId">
                            <el-input
                                size="medium"
                                v-model="form.adminPersonId"
                                style="max-width: 400px;"
                                placeholder="请输入分账方企业名称"
                            ></el-input>
                        </el-form-item>
                        <!-- 分账方企业银行账户 -->
                        <el-form-item label="分账方企业银行账户" prop="superAdminPhone">
                            <el-input
                                size="medium"
                                v-model="form.superAdminPhone"
                                style="max-width: 400px;"
                                placeholder="用于接收短信验证和通知"
                            ></el-input>
                        </el-form-item>
                        <!-- 分账类型 -->
                        <el-form-item label="分账类型" prop="splitType">
                            <el-radio-group v-model="form.splitType">
                                <el-radio
                                    v-for="item in splitTypeSelectList"
                                    :key="item.value"
                                    :label="item.label"
                                    :disabled="item.disabled && (reshowData && commonQualificationDto.splitType)"
                                >
                                    {{ item.label }}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <!-- 分账比例 -->
                        <el-form-item label="分账比例/金额" prop="platformPortion">
                            <el-input
                                size="medium"
                                v-model="form.platformPortion"
                                style="max-width: 400px;"
                                placeholder="请输入数字"
                            >
                            </el-input>
                            <span v-show="+form.splitType === 1">%</span>
                            <span v-show="+form.splitType === 2">元</span>
                        </el-form-item>
                    </div>
                </div>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">立即创建</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- step2 开户验证 -->
        <div v-if="active === 1">
            <p class="sub-title">开户验证</p>
            <div class="sub-note">请您参考以下信息，使用对应付款账户和卡号，汇款指定金额到指定账户，完成开户验证</div>
            <div v-if="accountValidationParams.account_name" class="verify-item">
                <div>付款户名：</div>
                <div>{{accountValidationParams.account_name || ''}}</div>
            </div>
            <div v-if="accountValidationParams.account_no" class="verify-item">
                <div>付款卡号：</div>
                <div>{{accountValidationParams.account_no || ''}}</div>
            </div>
            <div v-if="accountValidationParams.pay_amount" class="verify-item">
                <div>汇款金额：</div>
                <div style="color:red; font-weight:600; font-size: 20px">{{accountValidationParams.pay_amount || ''}}元</div>
            </div>
            <div v-if="accountValidationParams.destination_account_number" class="verify-item">
                <div>收款卡号：</div>
                <div>{{accountValidationParams.destination_account_number || ''}}</div>
            </div>
            <div v-if="accountValidationParams.destination_account_name" class="verify-item">
                <div>收款户名：</div>
                <div>{{accountValidationParams.destination_account_name || ''}}</div>
            </div>
            <div v-if="accountValidationParams.destination_account_bank" class="verify-item">
                <div>收款开户银行：</div>
                <div>{{accountValidationParams.destination_account_bank || ''}}</div>
            </div>
            <div v-if="accountValidationParams.city" class="verify-item">
                <div>收款银行省市：</div>
                <div>{{accountValidationParams.city || ''}}</div>
            </div>
            <div class="verify-item">
                <div>备注信息：</div>
                <div>{{accountValidationParams.remark || ''}}</div>
            </div>
            <div class="verify-item">
                <div>汇款截止时间：</div>
                <div style="color:red; font-weight:600;">{{accountValidationParams.deadline || ''}}</div>
            </div>
        </div>
        <!-- step3 开户审核 -->
        <div v-if="active === 2 && !underReview">
            <p class="sub-title">开户审核</p>
            <div class="verify-item">
                <div>审核结果</div>
                <div>{{auditDetail && auditDetail.reject_reason || ''}}</div>
            </div>
            <el-button type="primary" @click="goEdit">去修改</el-button>
        </div>
        <!-- step4 扫码签约 -->
        <div v-if="active === 3">
            <p class="sub-title">扫码签约</p>
            <div class="sub-note">您的开户信息已通过审核，请使用法人/经办人实名认证的微信账户扫码完成签约，签约后2小时完成开户，请不要重复扫码签约。</div>
            <div class="qrcode-box">
                <div>请扫码签约：</div>
                <vue-qr :logoSrc="imageUrl" :text="qrcodeUrl" :size="200"></vue-qr>
            </div>
        </div>
        <!-- step5 开户成功 -->
        <div v-if="active === 4">
            恭喜您，开户成功！
        </div>
        <!-- 提交完资料并且审核中 -->
        <div v-if="underReview">
            <p class="sub-title">信息审核中</p>
            <div class="verify-item">
                <div>开户名：</div>
                <div>{{accountInfoVo.bankAccount || ''}}</div>
            </div>
            <div class="verify-item">
                <div>银行卡号：</div>
                <div>{{accountInfoVo.accountNumber || ''}}</div>
            </div>
            <div class="verify-item">
                <div>开户银行：</div>
                <div>{{accountInfoVo.bankName || ''}}</div>
            </div>
            <div class="verify-item">
                <div>开户支行：</div>
                <div>{{accountInfoVo.bankBranchName || ''}}</div>
            </div>
            <div class="verify-item">
                <div>提交时间：</div>
                <div>{{accountInfoVo.submitTime || ''}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    ocrBusinessLicense,
    ocrIdCard,
    submitWechat,
    wechatJointQuery,
    aiqichaGetInfo,
    getIndustryList,
    getBankcityList,
    getQualificationQuery
} from "../../api/apiMap/index.js";
import {
    legalPersonTypeList,
    supplierTypeSelectList,
    bankAccountTypeSelectList,
    superAdminTypeSelectList,
    capitalSettlementTypeList,
    splitTypeSelectList,
    benefitTypeList,
} from "../../utils/list.js";
import {rules} from "./rule.js";
import imgUpload from "../../components/imgUpload/index.vue";
import vueQr from 'vue-qr'
export default {
    components: {
        imgUpload,
        vueQr
    },
    mounted() {
        const appId = this.$route.query.appId || '';

        this.appId = appId;
        if (appId) {
            this.newCreate = true;
            this.init(appId);
        } else {
            this.active = 0;
            this.loading = false;
        }
        this.getIndustry();
        this.getBankcitys();
	},
    data() {
        return {
            appId: '', // 商户appId
            // 0, "初始状态，待提交"
            // 1, "审核中"
            // 2, "待账户验证"
            // 3, "已驳回"
            // 4, "待签约"
            // 5, "已冻结"
            // 6, "进件完成"
            // 7, "已作废"
            // 8, "资料校验中"
            loading: true,
            ocrLoading: false,
            imageUrl: require("./logo.jpg"),
            active: -1,
            underReview: false, // 是否正在审核中
            qrcodeUrl: '',
            industryListData:[], // 行业列表
            industryListDataLevel2: null, // 第二列行业列表
            industryListDataLevel3: null, // 第三列行业列表
            industryLevel1: '',
            industryLevel2: '',
            industryLevel3: '',
            industryResult: '',
            bankCityList: [], // 银行城市列表
            bankCityListLevel2: null, // 第二列银行城市列表
            bankCityLevel1: '',
            bankCityLevel2: '',
            bankCityResult: '',
            licenselongtime: false, // 营业执是否长期有效
            legallongtime: false, // 身份证是否长期有效
            reshowData: false, // 是否有回显数据
            commonQualificationDto: null, // 共性资质副本
            form: {
                newCreate: false,
                supplierType: null, // 主体类型
                // --------法人相关---------
                legalPersonType: '', // 证件类型
                legalId: '', // 身份证号
                legalPerson: '', // 姓名
                legalCardStartTime: '', // 证件有效期开始时间
                legalCardEndTime: '', // 证件有效期结束时间
                legalPersonAddress: '', // 身份证地址
                owner: '', // 受益人是法人吗
                idCardFrontUrl: '', // 身份证正面
                idCardBackUrl: '', // 身份证反面
                appName: '', // 服务名称
                servicePhone: '', // 客服电话
                merchantShortName: '', // 支付商家名称
                payMerchantTitleUrl: '', // 支付商家头像
                storeUrl: '', // 支付商家跳转链接
                // --------营业执照自动填充---------
                businessLicense: '', // 营业执照号，统一社会信用代码
                licenseUrl: '', // 营业执照图片
                companyName: '', // 企业名称 瑞昌市典冉至百货商行
                industryId: '', // 行业id
                // socialCreditCode: '', // 统一社会信用代码 92360481MACCLBX712
                // type: '', // 公司类型
                // registeredCapital: '', // 注册资本
                businessProvince: '', // 经营省份
                businessCity: '', // 经营城市
                businessDetailAddress: '', // 经营详细地址
                businessScope: '', // 经营范围
                licenseStartTime: '', // 营业执照有效期开始时间
                licenseEndTime: '', // 营业执照有效期结束时间
                // --------超级管理员---------
                superAdminType: '', // 超级管理员类型
                superAdminName: '', // 姓名
                adminPersonId: '', // 身份证号
                adminCardStartTime: '', // 身份证开始
                adminCardEndTime: '', // 身份证结束
                superAdminPhone: '', // 手机号
                superAdminEmail: '', // 邮箱
                adminFrontUrl: '', // 超级管理员身份证正面
                adminBackUrl: '', // 超级管理员身份证反面
                businessAuthorizationLetterUrl: '', // 业务办理授权函
                qualifications: '', // 特殊资质
                // --------商户结算账户信息---------
                bankAccountType: null, // 账户类型
                bankAccount: '', // 开户名
                accountNumber: '', // 银行卡号
                bankName: '', // 开户银行名称
                bankBranchName: '', // 开户银行支行名称
                paymentDays: 1, //结算周期天数
                capitalSettlementType: 1, // 结算周期固定传1
                commissionRateStr: '', // 佣金比例字符串
                splitType: null, // 分账类型
                benefitList: [], // 受益人列表
            },
            isSplit: '0', // 是否分账
            rules: rules,
            // 主体类型列表
            supplierTypeSelectList: supplierTypeSelectList, // 主体类型
            legalPersonTypeList: legalPersonTypeList, // 证件类型
            bankAccountTypeSelectList: bankAccountTypeSelectList, // 账户类型
            superAdminTypeSelectList: superAdminTypeSelectList, // 超级管理员类型
            capitalSettlementTypeList: capitalSettlementTypeList, // 结算周期
            splitTypeSelectList: splitTypeSelectList, // 分账类型
            benefitTypeList: benefitTypeList, // 受益人类型
            accountValidationParams: {}, // 账户验证参数
            auditDetail: {}, // 审核详情
            accountInfoVo: {}, // 账户信息
            noNameAndNoCode: false,
        };
    },
    watch: {
        // 当 industryLevel1 改变时更新 industryResult
        industryLevel1() {
            this.updateIndustryResult();
        },
        // 当 industryLevel2 改变时更新 industryResult
        industryLevel2() {
            this.updateIndustryResult();
        },
        // 当 industryLevel3 改变时更新 industryResult
        industryLevel3() {
            this.updateIndustryResult();
        },
        bankCityLevel1() {
            this.updateBankCityResult();
        },
        bankCityLevel2() {
            this.updateBankCityResult();
        }
    },
    methods: {
        init(appId) {
            // 获取当前状态
            // let params = {
            //     appId: 336343 //审核成功
            //     appId: 336276 //审核失败
            //     appId: 489563 //待签约
            //     appId: 490457
            // }
            wechatJointQuery({
                appId
            }).then((result) => {
                this.loading = false;
                const params = result.data;
                // params.applymentState = 3
                switch (params.applymentState) {
                    case 0:
                        // 提交资料
                        this.active = 0;
                        // 查看有无存量数据
                        this.getQualificationQuery();
                        break;
                    case 1:
                        // 开户审核，审核中
                        this.active = 2;
                        this.underReview = true;
                        break;
                    case 2:
                        // 开户验证
                        this.active = 1;
                        break;
                    case 3:
                        // 感知不到5和7，都是3
                        // 审核驳回，还是审核中状态
                        this.active = 2;
                        // 查看有无存量数据
                        this.getQualificationQuery();
                        break;
                    case 4:
                        // 签约
                        this.active = 3;
                        // 设置二维码
                        this.qrcode = params.signUrl;
                        break;
                    case 6:
                        // 完成
                        this.active = 4;
                        this.$router.push({
                            path: "/serverDetail",
                            query:{
                                appId: this.appId
                            }
                        })
                        break;
                    default:
                        this.active = 0;
                }
                // 存在开户验证信息
                if (params.accountValidation) {
                    this.accountValidationParams = JSON.parse(params.accountValidation);
                }
                // 存在审核错误信息
                if (params.auditDetail) {
                    this.auditDetail = JSON.parse(params.auditDetail)[0];
                }
                // 存在审核中信息
                if (params.accountInfoVo) {
                    this.accountInfoVo = JSON.parse(params.accountInfoVo);
                }
            })
        },
        // 回显写入
        getQualificationQuery() {
            getQualificationQuery({
                appId: this.appId
            }).then((result) => {
                const commonQualificationDto = this.formatReshowData(result.data.commonQualificationDto);
                // 存一份用来判断回显可修改否
                this.commonQualificationDto = commonQualificationDto;
                console.log(commonQualificationDto);
                if (commonQualificationDto) {
                    this.reshowData = true;
                }
                const wechatQualificationDto = result.data.wechatQualificationDto;
                // 回显图片
                this.form = Object.assign({}, this.form, commonQualificationDto, wechatQualificationDto);
                this.handleSuperAdminTypeChange(wechatQualificationDto.superAdminType)
                if (this.active === 0) {
                    this.goEdit();
                }
            })
        },
        // 转化后端返回回显数据
        formatReshowData(params) {
            const camelCaseParams = {};
            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    camelCaseParams[this.toCamelCase(key)] = params[key];
                }
            }
            console.log(camelCaseParams, '转化后端返回回显数据');
            return camelCaseParams;
        },
        toCamelCase(str) {
            return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
        },
        submitForm(formName) {
            console.log(this.form, '表单数据')
            try{
                this.$refs[formName].validate((valid) => {
                    console.log(valid, 'aaaaa')
                    if (valid) {
                        console.log('表单验证通过')
                        let params = this.form;
                        submitWechat(params).then((result) => {
                            const appId = result.data && result.data.appId;
                            if (appId) {
                                this.$message({
                                    message: '创建成功',
                                    type: 'success'
                                });
                                this.init(appId);
                                this.active = 2;
                                // 添加 appId 到 URL 作为查询参数
                                const currentUrl = new URL(window.location.href);
                                currentUrl.searchParams.set('appId', appId);
                                window.history.pushState({ appId: appId }, '', currentUrl.href);
                            } else {
                                console.log(result)
                                this.$message({
                                    message: result.msg,
                                    type: 'warning'
                                });
                            }
                        })
                    } else {
                        this.$message({
                            message: '表单验证失败,请检查必填项。',
                            type: 'warning'
                        });
                        return false;
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
        goEdit() {
            //  回显图片必须在跳转到0状态才能加载dom
            this.active = 0;
            setTimeout(() => {
                this.reshowImg();
            }, 1000);
        },
        // 回显图片
        reshowImg() {
            if (this.form.idCardFrontUrl) {
                this.$refs.myLegalUploadFront.updateFileList([
                    {
                        name: '法人身份证正面.jpg',
                        url: this.form.idCardFrontUrl,
                        status: 'success'
                    }
                ]);
            }
            if (this.form.idCardBackUrl) {
                this.$refs.myLegalUploadEnd.updateFileList([
                    {
                        name: '法人身份证反面.jpg',
                        url: this.form.idCardBackUrl,
                        status: 'success'
                    }
                ]);
            }
            if (this.form.licenseUrl) {
                this.$refs.myLicenseUpload.updateFileList([
                    {
                        name: '营业执照图片.jpg',
                        url: this.form.licenseUrl,
                        status: 'success'
                    }
                ]);
            }
            if (this.form.adminFrontUrl) {
                this.$refs.myAdminUploadFront.updateFileList([
                    {
                        name: '管理员身份证反面.jpg',
                        url: this.form.adminFrontUrl,
                        status: 'success'
                    }
                ]);
            }
            if (this.form.adminBackUrl) {
                this.$refs.myAdminUploadEnd.updateFileList([
                    {
                        name: '管理员身份证反面.jpg',
                        url: this.form.adminBackUrl,
                        status: 'success'
                    }
                ]);
            }
            if (this.form.businessAuthorizationLetterUrl) {
                this.$refs.myAuthorizationLetterUpload.updateFileList([
                    {
                        name: '业务办理授权函.jpg',
                        url: this.form.businessAuthorizationLetterUrl,
                        status: 'success'
                    }
                ]);
            }
            if (this.form.qualifications) {
                this.$refs.myQualificationsUpload.updateFileList([
                    {
                        name: '特殊资质信息.jpg',
                        url: this.form.qualifications,
                        status: 'success'
                    }
                ]);
            }
        },
        // 纸质营业执照上传
        handleChildUploadSuccess(response) {
            if (response.data && response.data.imgUrl) {
                this.form.licenseUrl = response.data.imgUrl;
                // 处理从子组件传递过来的响应数据
                console.log('文件上传成功！', response);
                this.searchBusinessLicense();
                this.ocrLoading = true;
            }
        },
        searchBusinessLicense() {
            ocrBusinessLicense({
                businessLicenseUrl: this.form.licenseUrl
            }).then((result) => {
                console.log(result, '纸质营业执照识别结果');
                const params = {
                    companyName: result.data.companyName, // 企业名称
                    businessLicense: result.data.socialCreditCode, // 营业执照号
                    businessDetailAddress: result.data.address, // 经营地区详细地址
                    businessScope: result.data.businessScope, // 经营范围
                    businessProvince: result.data.district, // 省
                    businessCity: result.data.district, // 市
                }
                this.form = Object.assign({}, this.form, params, result.data);
                if (result.data.companyName || result.data.socialCreditCode) {
                    this.noNameAndNoCode = false;
                    this.aiqichaGetInfo(result.data);
                    console.log(result.data.companyName,result.data.socialCreditCode )
                } else {
                    this.noNameAndNoCode = true;
                    this.ocrLoading = false;
                    alert('无法识别您企业信息，请重新上传清晰图片或者手动填写')
                }
            })
        },
        aiqichaGetInfo(data) {
            const socialCreditCode = data ? data.socialCreditCode : this.businessLicense
            const params = {
                socialCreditCode
            }
            aiqichaGetInfo(params).then((result) => {
                console.log(result, 'aiqichaGetInfo');
                const params = {
                    // 营业执照开始时间
                    licenseStartTime: result.data.openTimeStart,
                    // 营业执照结束时间
                    licenseEndTime: result.data.openTimeEnd,
                    businessLicense: result.data.taxNo,
                    // registeredCapital: result.data.regCapital,
                }
                this.form = Object.assign({}, this.form, params);
                this.ocrLoading = false;
            }).catch((error) => {
                console.log(error)
            })
        },
        handleLegalIdCardFrontUploadSuccess(response) {
            if (response.data && response.data.imgUrl) {
                // 法人身份证正面
                this.form.idCardFrontUrl = response.data.imgUrl;
                ocrIdCard({
                    idCardUrl: response.data.imgUrl,
                    idCardSide: 'front'
                }).then((result) => {
                    console.log(result, '身份证正面识别结果');
                    this.form = Object.assign({}, this.form, result.data);
                    let params = {
                        legalPerson: result.data.name, // 姓名
                        legalId: result.data.idCard, // 身份证号
                        legalPersonAddress: result.data.address, // 地址
                    }
                    this.form = Object.assign({}, this.form, params);
                })
            }
        },
        handleLegalIdCardBackUploadSuccess(response) {
            if (response.data && response.data.imgUrl) {
                // 法人身份证背面
                this.form.idCardBackUrl = response.data.imgUrl;
                ocrIdCard({
                    idCardUrl: response.data.imgUrl,
                    idCardSide: 'back'
                }).then((result) => {
                    console.log(result, '身份证背面识别结果');
                    let params = {
                        legalCardStartTime: this.formatDate(result.data.startDate), // 身份证有效期
                        legalCardEndTime: this.formatDate(result.data.endDate), // 身份证有效期
                    }
                    this.form = Object.assign({}, this.form, params);
                })
            }
        },
        formatDate (dateStr) {
            return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
        },
        handleIdCardFrontUploadSuccess(response) {
            if (response.data && response.data.imgUrl) {
                this.form.adminFrontUrl = response.data.imgUrl;
                ocrIdCard({
                    idCardUrl: response.data.imgUrl,
                    idCardSide: 'front'
                }).then((result) => {
                    console.log(result, '身份证正面识别结果');
                    this.form = Object.assign({}, this.form, result.data);
                    let params = {
                        superAdminName: result.data.name, // 姓名
                        adminPersonId: result.data.idCard, // 身份证号
                    }
                    this.form = Object.assign({}, this.form, params);
                })
            }
        },
        handleIdCardBackUploadSuccess(response) {
            if (response.data && response.data.imgUrl) {
                // 身份证背面
                this.form.adminBackUrl = response.data.imgUrl;
                ocrIdCard({
                    idCardUrl: response.data.imgUrl,
                    idCardSide: 'back'
                }).then((result) => {
                    console.log(result, '身份证背面识别结果');
                    let params = {
                        adminCardStartTime: this.formatDate(result.data.startDate), // 身份证有效期
                        adminCardEndTime: this.formatDate(result.data.endDate), // 身份证有效期
                    }
                    this.form = Object.assign({}, this.form, params);
                })
            }
        },
        handlePayMerchantdUploadSuccess(response) {
            if (response.data && response.data.imgUrl) {
                const url = response.data.imgUrl;
                this.form.payMerchantTitleUrl = url;
            }
        },
        businessAuthorizationLetterUrlUploadSuccess(response) {
            if (response.data && response.data.imgUrl) {
                const url = response.data.imgUrl;
                this.form.businessAuthorizationLetterUrl = url;
            }
        },
        qualificationsUploadSuccess(response) {
            if (response.data && response.data.imgUrl) {
                const url = response.data.imgUrl;
                this.form.qualifications = url;
            }
        },
        getIndustry() {
            getIndustryList({
                industryCode: '0'
            }).then((result) => {
                this.industryListData = result.data;
                console.log(result, '行业信息');
            })
        },
        getBankcitys() {
            getBankcityList({
                sequence:  new Date().getTime(),
                from: 'fe',
                randomStr: new Date().getTime(),
            }).then((result) => {
                this.bankCityList = result.data.provinces;
                console.log(result, '城市信息');
            })
        },
        // 省份发生变化
        handleChangeCity1(value) {
            this.bankCityListLevel2 = this.bankCityList[value].cities;
            console.log(this.bankCityList[value].cities, '城市信息11111');
            this.bankCityLevel2 = null;
        },
        handleChangeCity2(value) {
            console.log(value);
        },
        handleChangeLevel1(value) {
            this.industryListDataLevel2 = this.industryListData[value].industryList;
            this.industryLevel2 = null;
            this.industryLevel3 = null;
        },
        handleChangeLevel2(value) {
            this.industryListDataLevel3 = this.industryListDataLevel2[value].industryList || null;
            this.industryLevel3 = null;
        },
        handleChangeLevel3() {
            console.log(this.industryLevel3, '行业信息3');
        },
        updateIndustryResult() {
            const level1 = this.industryLevel1 ? this.industryLevel1 : -1;
            const level2 = this.industryLevel2 ? this.industryLevel2 : -1;
            const level3 = this.industryLevel3 ? this.industryLevel3 : -1;
            let result = null;
            if (level3 >= 0) {
                result = this.industryListDataLevel3[level3].industryId;
            } else if (level2 >= 0) {
                result = this.industryListDataLevel2[level2].industryId;
            } else if (level1 >= 0) {
                result = this.industryListData[level1].industryId;
            }
            this.industryResult = result;
            this.form.industryId = result;
        },
        updateBankCityResult() {
            console.log(this.bankCityLevel1, '省份信息');
            console.log(this.bankCityLevel2, '城市信息');
            this.form.businessProvince = this.bankCityList[this.bankCityLevel1].provinceName;
            if (this.bankCityLevel2) {
                this.form.businessCity = this.bankCityList[this.bankCityLevel1].cities[this.bankCityLevel2].cityName
            }
        },
        handleLegalLongTimeChange(value) {
            if (value) {
                this.form.legalCardStartTime = '9999-12-31';
                this.form.legalCardEndTime = '9999-12-31';
            } else {
                this.form.legalCardStartTime = '';
                this.form.legalCardEndTime = '';
            }
        },
        // 营业执照长期有效按钮变化
        handleLicenseLongTimeChange(value) {
            if (value) {
                this.form.licenseStartTime = '9999-12-31';
                this.form.licenseEndTime = '9999-12-31';
            } else {
                this.form.licenseStartTime = '';
                this.form.licenseEndTime = '';
            }
        },
        supplierTypeChange(val) {
            // 先不做任何事情，后续根据供应商类型变化有细节微调
            console.log(val, '供应商类型变化');
        },
        // 身份证类型变化,清空身份证信息
        legalPersonTypeChange() {
            this.form.legalPerson = '';
            this.form.legalId = '';
            this.form.legalCardStartTime = '';
            this.form.legalCardEndTime = '';
            this.form.idCardFrontUrl = '';
            this.form.idCardBackUrl = '';
            this.form.legalPersonAddress = '';
            try{
                this.$refs.myLegalUploadFront.updateFileList([]);
                this.$refs.myLegalUploadEnd.updateFileList([]);
            } catch (error) {
                console.log('没有上传组件');
            }

        },
        // 受益人变化
        handleBenefitChange(value) {
            console.log(value, '受益人变化');
        },
        // 超级管理员类型变化
        handleSuperAdminTypeChange(val) {
            if (val === 65) {
                // 如果val= 65
                // 则将法人信息同步为超级管理员信息
                const params = {
                    superAdminName: this.form.legalPerson, // 姓名
                    adminPersonId: this.form.legalId, // 身份证号
                    adminCardStartTime: this.form.legalCardStartTime, // 身份证开始
                    adminCardEndTime: this.form.legalCardEndTime, // 身份证结束
                    adminFrontUrl: this.form.idCardFrontUrl, // 超级管理员身份证正面
                    adminBackUrl: this.form.idCardBackUrl, // 超级管理员身份证反面
                }
                this.form = Object.assign({}, this.form, params);
                // 回显管理员图片信息
                if (this.form.adminFrontUrl) {
                    this.$refs.myAdminUploadFront.updateFileList([
                        {
                            name: '管理员身份证反面.jpg',
                            url: this.form.adminFrontUrl,
                            status: 'success'
                        }
                    ]);
                }
                if (this.form.adminBackUrl) {
                    this.$refs.myAdminUploadEnd.updateFileList([
                        {
                            name: '管理员身份证反面.jpg',
                            url: this.form.adminBackUrl,
                            status: 'success'
                        }
                    ]);
                }
            } else {
                const params = {
                    superAdminName: '', // 姓名
                    adminPersonId: '', // 身份证号
                    adminCardStartTime: '', // 身份证开始
                    adminCardEndTime: '', // 身份证结束
                    adminFrontUrl: '', // 超级管理员身份证正面
                    adminBackUrl: '', // 超级管理员身份证反面
                }
                this.form = Object.assign({}, this.form, params);
                // 清空管理员图片信息
                this.$refs.myAdminUploadFront.updateFileList([]);
                this.$refs.myAdminUploadEnd.updateFileList([]);
            }
        }
    }
};
</script>
<style lang="less">
.container-verifypage{
    .mgb-60{
        margin-bottom: 60px;
    }
    .mgl-100{
        margin-left: 176px;
    }
    .upload-box{
        border: 1px solid #dcdfe6;
        padding: 20px;
        box-sizing: border-box;
        margin-bottom: 20px;
    }
    .area-box{
        display: flex;
        margin-bottom: 20px;
        .area-title{
            line-height: 40px;
            white-space: nowrap;
            min-width: 130px;
            margin-right: 50px;
        }
        .area-content{
            background: #f5f7f9;
            padding: 20px 80px;
        }
    }
    .sub-title{
        border-left: 10px solid #4D7DfD;
        color: #4D7DfD;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        font-weight: 600;
        padding-left: 20px;
        margin-bottom: 20px;
    }
    .sub-note{
        color: #aaa;
        font-size: 12px;
    }
    .qrcode-box{
        margin-top: 20px;
        background: #F3F4F5;
        padding: 20px;
        display: inline-block;
    }
    .idcard-box{
        display: flex;
    }
    .verify-item{
        display: flex;
        // justify-content: space-between;
        padding: 20px 0;
        border-bottom: 1px solid #f5f7f9;
        div:first-child{
            width: 200px;
            font-weight: 600;
        }
        div{
            width: 400px;
            word-wrap: break-word;
        }
    }
    .split-box{
        display: flex;
    }
    .flex-box{
        display: flex;
    }
}
</style>
